import { useMemo } from "react";
import { DashBoardDateRangePicker } from "../../../modules";
import { useActivityLogTable } from "../../hooks";
import { Button } from "@mui/material";
import { ServerPaginatedTable } from "../ServerPaginatedTable";
import { ActivityLogDetailsDialog } from "./ActivityLogDetailsDialog";

export const ActivityLogTable = ({ subjectType, id }) => {
  const {
    state,
    gotoPage,
    setPageSize,
    onOpenDateRangeSelection,
    onOpenCloseActivityLogDialog,
    handleDateChangeApply,
    onFilterSelection,
    onClearAllFilter,
  } = useActivityLogTable({ subjectType, id });

  const columns = useMemo(
    () => [
      {
        Header: "Date & Time",
        accessor: "date",
      },
      {
        Header: "User",
        accessor: "user",
      },
      {
        Header: "Description",
        accessor: (row) =>
          row.description?.startsWith("App\\")
            ? row.description.split("\\")[2] || "-"
            : row.description || "-",
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        accessor: () => {
          return (
            <Button
              type="button"
              size="medium"
              variant="text"
              color="info"
              sx={{
                p: "8px",
              }}
              onClick={onOpenCloseActivityLogDialog}
            >
              View Changes
            </Button>
          );
        },
      },
    ],
    [onOpenCloseActivityLogDialog],
  );

  return (
    <>
      <ServerPaginatedTable
        tableTitle="Activity Log"
        searchBar={false}
        columns={columns}
        data={state.activityLogList}
        isLoading={state.loading}
        defaultSearch={false}
        gotoPage={gotoPage}
        setPageSize={setPageSize}
        pagination={state.pagination}
        sortByGlobal={[]}
        manualSortBy={false}
        onRowAction={(row) => onOpenCloseActivityLogDialog(row.id)}
        filterSection={
          <ActivityLogListFilterSection
            filter={state.filter}
            onDateChangeApply={handleDateChangeApply}
            onOpenDateRangeSelection={onOpenDateRangeSelection}
            onFilterSelection={onFilterSelection}
          />
        }
        filterApplied={state.filter.appliedFilters}
        onAllFilterClear={onClearAllFilter}
        onFilterClear={onClearAllFilter}
      />
      {state.currentActivityLogId && (
        <ActivityLogDetailsDialog
          open={state.isOpenActivityDialog}
          handleDialogClose={() => onOpenCloseActivityLogDialog()}
          activityLogId={state.currentActivityLogId}
        />
      )}
    </>
  );
};

const ActivityLogListFilterSection = ({
  filter,
  onOpenDateRangeSelection,
  onDateChangeApply,
  onFilterSelection,
}) => {
  return (
    <DashBoardDateRangePicker
      label="Date Range"
      isList={true}
      range={filter.date.value}
      showRange={filter.date.showDate}
      isOpen={filter.date.isCalenderOpen}
      handleIsOpen={onOpenDateRangeSelection}
      handleDateChangeApply={onDateChangeApply}
      position="left"
      onChangeDate={(event) => {
        onFilterSelection({ value: event, type: "date_range" });
      }}
    />
  );
};
